function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ApiConstants, ThunkHelper } from 'invision-core';
export var RETRIEVE_ACCOUNT_STATUS_CONSTANTS = {
  BEGIN: 'RETRIEVE_ACCOUNT_STATUS_BEGIN',
  SUCCESS: 'RETRIEVE_ACCOUNT_STATUS_SUCCESS',
  FAILURE: 'RETRIEVE_ACCOUNT_STATUS_FAILURE'
};
var RETRIEVE_ACCOUNT_STATUS_EVENTS = [RETRIEVE_ACCOUNT_STATUS_CONSTANTS.BEGIN, RETRIEVE_ACCOUNT_STATUS_CONSTANTS.SUCCESS, RETRIEVE_ACCOUNT_STATUS_CONSTANTS.FAILURE];
export var retrieveCustomerAccountStatusPromise = function retrieveCustomerAccountStatusPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, RETRIEVE_ACCOUNT_STATUS_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveSubscriberStatistics',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var retrieveCustomerAccountStatus = function retrieveCustomerAccountStatus(customerId) {
  return function (dispatch) {
    return retrieveCustomerAccountStatusPromise(dispatch, customerId);
  };
};
export var SET_AUTO_PAY_BANNER_FLAG = 'SET_AUTO_PAY_BANNER_FLAG';
export var setCustomerAutoPayBannerFlag = function setCustomerAutoPayBannerFlag(page) {
  return {
    type: SET_AUTO_PAY_BANNER_FLAG,
    payload: page
  };
};